import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Also inject Bearer token if available (fallback for cross-site cookie issues)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("jsav_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
